module.exports = __webpack_public_path__ + "static/media/typescript-icon.8ecc6712.svg";